import { Capacitor } from '@capacitor/core';

/**
 * Set the app icon badge count (iOS/Android) using @capawesome/capacitor-badge.
 * Silently no-ops on the web. Imports the plugin lazily so the bundle does not
 * crash if the native plugin is unavailable on a given build.
 */
export async function setAppBadge(count) {
  try {
    if (!Capacitor.isNativePlatform()) return;
    const mod = await import('@capawesome/capacitor-badge');
    const Badge = mod?.Badge;
    if (!Badge) return;
    if (count <= 0) {
      await Badge.clear();
    } else {
      await Badge.set({ count });
    }
  } catch (_) {
    // ignore — plugin missing or permission not granted
  }
}
